import { ImageData } from 'shared/components/ui/optimized-image/optimized-image';
import { MovesEnum } from 'shared/constants/shared-enums';

import mePaperLose from 'assets/moves/me-paper-lost.png?format=webp;avif&as=picture';
import mePaperWin from 'assets/moves/me-paper-win.png?format=webp;avif&as=picture';
import mePaper from 'assets/moves/me-paper.png?format=webp;avif&as=picture';
import meRockLose from 'assets/moves/me-rock-lost.png?format=webp;avif&as=picture';
import meRockWin from 'assets/moves/me-rock-win.png?format=webp;avif&as=picture';
import meRock from 'assets/moves/me-rock.png?format=webp;avif&as=picture';
import meScissorsLose from 'assets/moves/me-scissors-lost.png?format=webp;avif&as=picture';
import meScissorsWin from 'assets/moves/me-scissors-win.png?format=webp;avif&as=picture';
import meScissors from 'assets/moves/me-scissors.png?format=webp;avif&as=picture';
import opponentPaperLose from 'assets/moves/opponent-paper-lost.png?format=webp;avif&as=picture';
import opponentPaperWin from 'assets/moves/opponent-paper-win.png?format=webp;avif&as=picture';
import opponentPaper from 'assets/moves/opponent-paper.png?format=webp;avif&as=picture';
import opponentRockLose from 'assets/moves/opponent-rock-lost.png?format=webp;avif&as=picture';
import opponentRockWin from 'assets/moves/opponent-rock-win.png?format=webp;avif&as=picture';
import opponentRock from 'assets/moves/opponent-rock.png?format=webp;avif&as=picture';
import opponentScissorsLose from 'assets/moves/opponent-scissors-lost.png?format=webp;avif&as=picture';
import opponentScissorsWin from 'assets/moves/opponent-scissors-win.png?format=webp;avif&as=picture';
import opponentScissors from 'assets/moves/opponent-scissors.png?format=webp;avif&as=picture';

export const imageMap: Record<string, ImageData> = {
  'me-paper-win': mePaperWin,
  'me-paper-lost': mePaperLose,
  'me-paper': mePaper,
  'me-rock-win': meRockWin,
  'me-rock-lost': meRockLose,
  'me-rock': meRock,
  'me-scissors-win': meScissorsWin,
  'me-scissors-lost': meScissorsLose,
  'me-scissors': meScissors,
  'opponent-paper-win': opponentPaperWin,
  'opponent-paper-lost': opponentPaperLose,
  'opponent-paper': opponentPaper,
  'opponent-rock-win': opponentRockWin,
  'opponent-rock-lost': opponentRockLose,
  'opponent-rock': opponentRock,
  'opponent-scissors-win': opponentScissorsWin,
  'opponent-scissors-lost': opponentScissorsLose,
  'opponent-scissors': opponentScissors,
};

export const moveName = (selectedMove: MovesEnum) => {
  switch (selectedMove) {
    case MovesEnum.Rock:
      return 'rock';
    case MovesEnum.Paper:
      return 'paper';
    case MovesEnum.Scissors:
      return 'scissors';
    default:
      return '';
  }
};
